package org.catharsis.spendtel.core.auth

data class GoogleAuthTokens(
    val idToken: String,
    val accessToken: String?,
)

expect object GoogleSignInProvider {
    suspend fun getGoogleTokens(): Result<GoogleAuthTokens>
}
